<template>
    <div class="tours__cont">
        <a :href="tour.slug | permalink(lang)" class="tour_card" v-for="tour in tours" :key="tour.id">
            <div class="tour_card__image" :style="{ backgroundImage: 'url(' + tour.thumbnail + ')' }">
                <div class="tour_card__image__cont">
                    <div class="tour_card__cat" v-if="tour.interests.length > 0">
                        <span v-for="interest in tour.interests" :key="'interest_'+interest.id">{{ interest.name[lang] }}</span>
                    </div>
                    <div class="tour_card__title__cont">
                        <h3 class="tour_card__title">{{ tour.title[lang] }}</h3>
                        <div class="tour_card__desc" v-html="tour.excerpt"></div>
                    </div>
                </div>
            </div>
            <div class="tour_card__bottom">
                <ul>
                    <li><img src="/images/icons/duration_icon.svg" alt="duration" v-if="tour.duration">{{ tour.duration.name[lang] }}</li>
                    <li><img src="/images/icons/location_icon.svg" alt="location" v-if="tour.destination">{{ tour.destination.namejs[lang] | remove_parenthesis}}</li>
                    <li><img src="/images/icons/languages_icon_small.svg" alt="languages" v-if="tour.av_languages">{{ tour.av_languages }}</li>
                </ul>
            </div>
        </a>
        <a :href="`/${this.lang}/tailor-made`" class="tour_card tour_card--last">
            <div class="tour_card__image" style="background-image: url('/images/tour_card_tailored.jpg')">
                <div class="tour_card__image__cont">
                    <h5 class="tour_card__title">{{ translations.not_exactly }}</h5>
                    <h4 class="tour_card__tailor">{{ translations.tailor_your }}</h4>
                </div>
            </div>
        </a>
        <a href="#" class="tour_card tour_card--empty"></a>
        <a href="#" class="tour_card tour_card--empty"></a>
        <a href="#" class="tour_card tour_card--empty"></a>
        <a href="#" class="tour_card tour_card--empty"></a>
    </div>
</template>

<script>
    require('vue2-animate/dist/vue2-animate.min.css')
    export default {
        props: ['tours', 'translations'],
        data() {
            return {
                lang: "en",
            }
        },
        mounted() {
            this.lang = document.documentElement.lang;
        },
        methods: {
        },
        filters: {
            permalink: (value, lang) => {
                if(lang == "en"){
                    return `/themed/${value[lang]}`;
                }
                return `/${lang}/themed/${value[lang]}`;
            },
            remove_parenthesis: function (value) {
                if (!value) return ''
                value = value.toString()
                return value.replace(/ *\([^)]*\) */g, "");
            }
        }
    }
</script>
